import { View } from "@react-pdf/renderer";
import { ResumePDFDescription } from "components/Resume/ResumePDF/common";
import { TemplateTwoPDFSection, TemplateThreeEnhancedSection } from "./common";
import { spacing, styles } from "components/Resume/ResumePDF/styles";
import type { ResumeCustom } from "lib/redux/types";

export const Custom = ({
  heading,
  custom,
  enableMistakeHighlight = false,
}: {
  heading: string;
  custom: ResumeCustom;
  enableMistakeHighlight?: boolean;
}) => {
  const { descriptions } = custom;

  return (
    <TemplateThreeEnhancedSection heading={heading}>
      <View style={{ ...styles.flexRow, gap: spacing[1.5] }}>
        <View style={{ width: "21%" }}></View>
        <View style={{ width: "79%" }}>
          <ResumePDFDescription 
            items={descriptions} 
            enableMistakeHighlight={enableMistakeHighlight}
            section="custom"
            itemIndex={null}
          />
        </View>
      </View>
    </TemplateThreeEnhancedSection>
  );
};
